import { Link } from "react-router-dom";
import "./JavaFullStack.css";

const JavaFullStack = () => {
  const modules = [
    {
      no: "01",
      title: "Web Development Fundamentals",
      icon: "🌐",
      topics: [
        "Introduction to Web Development",
        "Client-Server Architecture",
        "HTTP & HTTPS",
        "Frontend vs Backend",
        "HTML5",
        "Semantic HTML",
        "Forms & Validation",
        "Tables, Lists & Multimedia",
        "CSS3",
        "Selectors & Box Model",
        "Flexbox & CSS Grid",
        "Responsive Web Design",
        "Media Queries",
        "CSS Animations & Transitions",
      ],
    },

    {
      no: "02",
      title: "JavaScript",
      icon: "🟨",
      topics: [
        "JavaScript Fundamentals",
        "Variables & Data Types",
        "Operators",
        "Conditional Statements",
        "Loops",
        "Functions",
        "Arrow Functions",
        "Arrays & Objects",
        "Destructuring",
        "Spread & Rest Operators",
        "Array Methods",
        "DOM Manipulation",
        "Event Handling",
        "Form Validation",
        "JSON",
        "Promises",
        "Async/Await",
        "Fetch API",
        "ES6+ Features",
      ],
    },

    {
      no: "03",
      title: "Core Java",
      icon: "☕",
      topics: [
        "Introduction to Java",
        "JDK, JRE & JVM",
        "Java Architecture",
        "Variables & Data Types",
        "Type Casting",
        "Operators",
        "Control Statements",
        "Loops",
        "Arrays",
        "Strings",
        "StringBuffer & StringBuilder",
        "Methods",
        "Constructors",
        "Packages",
        "Access Modifiers",
      ],
    },

    {
      no: "04",
      title: "Object Oriented Programming",
      icon: "🧩",
      topics: [
        "Class & Object",
        "Encapsulation",
        "Inheritance",
        "Polymorphism",
        "Method Overloading",
        "Method Overriding",
        "Abstraction",
        "Abstract Class",
        "Interfaces",
        "this Keyword",
        "super Keyword",
        "static Keyword",
        "final Keyword",
        "Composition",
        "Association",
      ],
    },

    {
      no: "05",
      title: "Exception Handling & Collections",
      icon: "📦",
      topics: [
        "Exception Handling",
        "Checked & Unchecked Exceptions",
        "try-catch-finally",
        "throw & throws",
        "Custom Exceptions",
        "Collection Framework",
        "List",
        "ArrayList",
        "LinkedList",
        "Vector",
        "Set",
        "HashSet",
        "LinkedHashSet",
        "TreeSet",
        "Queue",
        "PriorityQueue",
        "Map",
        "HashMap",
        "LinkedHashMap",
        "TreeMap",
        "Comparable",
        "Comparator",
        "Generics",
      ],
    },

    {
      no: "06",
      title: "Java 8 & Modern Java",
      icon: "⚡",
      topics: [
        "Lambda Expressions",
        "Functional Interfaces",
        "Predicate",
        "Consumer",
        "Supplier",
        "Function",
        "Method References",
        "Stream API",
        "filter()",
        "map()",
        "sorted()",
        "reduce()",
        "collect()",
        "Optional",
        "Date & Time API",
        "Default Methods",
        "Modern Java Features",
      ],
    },

    {
      no: "07",
      title: "Multithreading",
      icon: "🔄",
      topics: [
        "Process vs Thread",
        "Thread Lifecycle",
        "Creating Threads",
        "Thread Class",
        "Runnable",
        "Callable",
        "Synchronization",
        "Race Condition",
        "Deadlock",
        "ExecutorService",
        "Thread Pool",
        "Future",
        "CompletableFuture",
        "Concurrent Collections",
      ],
    },

    {
      no: "08",
      title: "MySQL & SQL",
      icon: "🗄️",
      topics: [
        "Database Fundamentals",
        "DBMS & RDBMS",
        "Database & Tables",
        "Primary Key",
        "Foreign Key",
        "DDL Commands",
        "DML Commands",
        "DQL Commands",
        "TCL Commands",
        "SELECT Queries",
        "WHERE",
        "ORDER BY",
        "GROUP BY",
        "HAVING",
        "Aggregate Functions",
        "Subqueries",
        "Joins",
        "Indexes",
        "Views",
        "Stored Procedures",
        "Triggers",
        "Transactions",
        "Normalization",
      ],
    },

    {
      no: "09",
      title: "JDBC",
      icon: "🔌",
      topics: [
        "Introduction to JDBC",
        "JDBC Architecture",
        "JDBC Drivers",
        "Connection",
        "Statement",
        "PreparedStatement",
        "CallableStatement",
        "ResultSet",
        "CRUD Operations",
        "Transactions",
        "Commit & Rollback",
        "Batch Processing",
        "Connection Pooling",
      ],
    },

    {
      no: "10",
      title: "Servlet & JSP",
      icon: "🖥️",
      topics: [
        "Servlet Introduction",
        "Servlet Architecture",
        "Servlet Lifecycle",
        "GenericServlet",
        "HttpServlet",
        "doGet()",
        "doPost()",
        "Request & Response",
        "ServletConfig",
        "ServletContext",
        "Cookies",
        "HttpSession",
        "URL Rewriting",
        "RequestDispatcher",
        "Filters",
        "Listeners",
        "JSP Introduction",
        "JSP Lifecycle",
        "JSP Directives",
        "JSP Actions",
        "Expression Language",
        "JSTL",
        "Implicit Objects",
      ],
    },

    {
      no: "11",
      title: "Hibernate & JPA",
      icon: "🔗",
      topics: [
        "ORM Concept",
        "Hibernate Architecture",
        "Configuration",
        "SessionFactory",
        "Session",
        "Transaction",
        "Entity Mapping",
        "@Entity",
        "@Id",
        "@GeneratedValue",
        "@Column",
        "One-to-One",
        "One-to-Many",
        "Many-to-One",
        "Many-to-Many",
        "Lazy Loading",
        "Eager Loading",
        "Cascade",
        "HQL",
        "JPQL",
        "Criteria API",
        "Pagination",
        "Caching",
      ],
    },

    {
      no: "12",
      title: "Spring Framework",
      icon: "🌱",
      topics: [
        "Introduction to Spring",
        "Spring Architecture",
        "IoC",
        "Dependency Injection",
        "Spring Beans",
        "ApplicationContext",
        "Bean Lifecycle",
        "Constructor Injection",
        "Setter Injection",
        "Component Scanning",
        "@Component",
        "@Service",
        "@Repository",
        "@Controller",
        "@Autowired",
        "@Configuration",
        "@Bean",
        "@Qualifier",
        "@Primary",
      ],
    },

    {
      no: "13",
      title: "Spring MVC",
      icon: "🏗️",
      topics: [
        "MVC Architecture",
        "DispatcherServlet",
        "Controller",
        "Model",
        "View",
        "Request Mapping",
        "@RequestMapping",
        "@GetMapping",
        "@PostMapping",
        "@PutMapping",
        "@DeleteMapping",
        "@PathVariable",
        "@RequestParam",
        "@RequestBody",
        "@ResponseBody",
        "Exception Handling",
      ],
    },

    {
      no: "14",
      title: "Spring Boot",
      icon: "🚀",
      topics: [
        "Introduction to Spring Boot",
        "Spring Boot Architecture",
        "Spring Initializr",
        "Starters",
        "Auto Configuration",
        "Embedded Server",
        "application.properties",
        "application.yml",
        "Profiles",
        "Configuration",
        "REST API",
        "HTTP Methods",
        "HTTP Status Codes",
        "JSON",
        "DTO",
        "Layered Architecture",
        "Controller Layer",
        "Service Layer",
        "Repository Layer",
      ],
    },

    {
      no: "15",
      title: "Spring Data JPA",
      icon: "💾",
      topics: [
        "Spring Data JPA",
        "Repository",
        "CrudRepository",
        "JpaRepository",
        "Query Methods",
        "@Query",
        "JPQL",
        "Native Query",
        "Pagination",
        "Sorting",
        "Specifications",
        "Transactions",
        "Entity Relationships",
        "DTO Projection",
      ],
    },

    {
      no: "16",
      title: "Spring Security & JWT",
      icon: "🔐",
      topics: [
        "Authentication",
        "Authorization",
        "Roles & Permissions",
        "Spring Security",
        "SecurityFilterChain",
        "AuthenticationManager",
        "AuthenticationProvider",
        "UserDetails",
        "UserDetailsService",
        "PasswordEncoder",
        "BCrypt",
        "JWT Introduction",
        "JWT Structure",
        "Token Generation",
        "Token Validation",
        "JWT Filter",
        "Role Based Authorization",
        "Protected APIs",
      ],
    },

    {
      no: "17",
      title: "React JS",
      icon: "⚛️",
      topics: [
        "Introduction to React",
        "React Architecture",
        "SPA",
        "Components",
        "JSX",
        "Props",
        "State",
        "Events",
        "Conditional Rendering",
        "Lists & Keys",
        "useState",
        "useEffect",
        "useContext",
        "useRef",
        "useMemo",
        "useCallback",
        "Forms",
        "Form Validation",
      ],
    },

    {
      no: "18",
      title: "React Advanced",
      icon: "⚛️",
      topics: [
        "React Router",
        "BrowserRouter",
        "Routes",
        "Route",
        "Link",
        "NavLink",
        "useNavigate",
        "useParams",
        "Axios",
        "API Integration",
        "Context API",
        "Redux",
        "Redux Toolkit",
        "Store",
        "Slice",
        "Actions",
        "Reducers",
        "Selectors",
        "Async Operations",
        "Protected Routes",
      ],
    },

    {
      no: "19",
      title: "React + Spring Boot Integration",
      icon: "🔄",
      topics: [
        "Frontend Backend Integration",
        "REST API Integration",
        "Axios",
        "CORS",
        "GET API",
        "POST API",
        "PUT API",
        "DELETE API",
        "DTO Integration",
        "Error Handling",
        "Loading States",
        "JWT Integration",
        "Authentication",
        "Authorization",
        "Role Based Access",
      ],
    },

    {
      no: "20",
      title: "DSA with Java",
      icon: "🧠",
      topics: [
        "Time Complexity",
        "Space Complexity",
        "Arrays",
        "Strings",
        "Searching",
        "Linear Search",
        "Binary Search",
        "Sorting",
        "Bubble Sort",
        "Selection Sort",
        "Insertion Sort",
        "Merge Sort",
        "Quick Sort",
        "Linked List",
        "Stack",
        "Queue",
        "Hashing",
        "Binary Tree",
        "BST",
        "Graphs",
        "Recursion",
        "Backtracking",
        "Dynamic Programming",
      ],
    },

    {
      no: "21",
      title: "Testing & API Tools",
      icon: "🧪",
      topics: [
        "Software Testing Basics",
        "Unit Testing",
        "JUnit",
        "Mockito",
        "Mocking",
        "Service Testing",
        "Controller Testing",
        "Postman",
        "API Testing",
        "Request Testing",
        "Response Validation",
        "JWT Testing",
      ],
    },

    {
      no: "22",
      title: "Git, GitHub & Deployment",
      icon: "☁️",
      topics: [
        "Git Fundamentals",
        "Repository",
        "Commit",
        "Branch",
        "Merge",
        "Clone",
        "Pull",
        "Push",
        "GitHub",
        "Pull Request",
        ".gitignore",
        "Build & Deployment",
        "Environment Variables",
        "Docker Introduction",
        "Dockerfile",
        "Docker Compose",
        "Production Deployment",
      ],
    },

    {
      no: "23",
      title: "Full Stack Projects",
      icon: "💼",
      topics: [
        "CRM Application",
        "HRMS Application",
        "E-Commerce Application",
        "Employee Management System",
        "Authentication & Authorization",
        "Admin Dashboard",
        "User Dashboard",
        "CRUD Operations",
        "REST API",
        "JWT Authentication",
        "Role Based Access",
        "Database Design",
        "React Frontend",
        "Spring Boot Backend",
        "MySQL Database",
        "Project Deployment",
      ],
    },

    {
      no: "24",
      title: "Interview & Placement Preparation",
      icon: "🎯",
      topics: [
        "Core Java Interview Questions",
        "OOP Interview Questions",
        "Collections Interview Questions",
        "Java 8 Interview Questions",
        "Multithreading Questions",
        "SQL Interview Questions",
        "Spring Boot Questions",
        "Hibernate Questions",
        "REST API Questions",
        "Spring Security Questions",
        "React Interview Questions",
        "DSA Coding Problems",
        "Project Explanation",
        "Resume Preparation",
        "Mock Interviews",
      ],
    },
  ];

  return (
    <div className="java-page">

      {/* ================= HERO ================= */}

      <section className="java-hero">

        <div className="java-hero-content">

          <span>JOB-ORIENTED TRAINING PROGRAM</span>

          <h1>
            Java Full Stack
            <strong>Development</strong>
          </h1>

          <p>
            Learn complete full stack development from Core Java
            to Spring Boot, React, MySQL, REST APIs, JWT,
            DSA and real-world projects.
          </p>

          <div className="java-hero-buttons">
            <a href="#java-syllabus">
              View Complete Syllabus
            </a>

            <Link to="/contact">
              Enquire Now
            </Link>
          </div>

        </div>

      </section>


      {/* ================= COURSE OVERVIEW ================= */}

      <section className="java-overview">

        <div className="overview-card">
          <strong>24+</strong>
          <span>Learning Modules</span>
        </div>

        <div className="overview-card">
          <strong>10+</strong>
          <span>Technologies</span>
        </div>

        <div className="overview-card">
          <strong>3+</strong>
          <span>Major Projects</span>
        </div>

        <div className="overview-card">
          <strong>100%</strong>
          <span>Practical Training</span>
        </div>

      </section>


      {/* ================= SYLLABUS ================= */}

      <section
        id="java-syllabus"
        className="java-syllabus"
      >

        <div className="syllabus-heading">

          <span>COURSE CURRICULUM</span>

          <h2>
            Complete Java Full Stack Syllabus
          </h2>

          <p>
            A structured learning path covering frontend,
            backend, database, DevOps, DSA and real-world
            full stack development.
          </p>

        </div>


        <div className="java-module-grid">

          {modules.map((module) => (

            <article
              className="java-module-card"
              key={module.no}
            >

              <div className="module-top">

                <span className="module-number">
                  {module.no}
                </span>

                <span className="module-icon">
                  {module.icon}
                </span>

              </div>

              <h3>
                {module.title}
              </h3>

              <ul>

                {module.topics.map((topic) => (

                  <li key={topic}>
                    <span>✓</span>
                    {topic}
                  </li>

                ))}

              </ul>

            </article>

          ))}

        </div>

      </section>


      {/* ================= TECHNOLOGY STACK ================= */}

      <section className="technology-section">

        <div className="syllabus-heading">

          <span>TECHNOLOGY STACK</span>

          <h2>
            Technologies You Will Learn
          </h2>

        </div>

        <div className="technology-grid">

          <div>☕ Java</div>
          <div>🌱 Spring Boot</div>
          <div>⚛️ React JS</div>
          <div>🗄️ MySQL</div>
          <div>🔗 Hibernate</div>
          <div>🔐 Spring Security</div>
          <div>🔑 JWT</div>
          <div>🟨 JavaScript</div>
          <div>🐙 Git & GitHub</div>
          <div>🐳 Docker</div>

        </div>

      </section>


      {/* ================= PROJECTS ================= */}

      <section className="java-projects">

        <div className="syllabus-heading">

          <span>REAL WORLD DEVELOPMENT</span>

          <h2>
            Projects You Will Build
          </h2>

        </div>

        <div className="project-training-grid">

          <article>
            <span>PROJECT 01</span>
            <h3>CRM Application</h3>
            <p>
              Customer and lead management system with
              authentication, dashboards and role-based access.
            </p>
          </article>

          <article>
            <span>PROJECT 02</span>
            <h3>HRMS Application</h3>
            <p>
              Employee management system with attendance,
              leave management and admin functionality.
            </p>
          </article>

          <article>
            <span>PROJECT 03</span>
            <h3>E-Commerce Application</h3>
            <p>
              Complete e-commerce application with products,
              cart, orders, authentication and admin dashboard.
            </p>
          </article>

        </div>

      </section>


      {/* ================= ENQUIRY ================= */}

      <section
        id="java-enquiry"
        className="java-enquiry"
      >

        <div>

          <span>START YOUR JOURNEY</span>

          <h2>
            Become a Java Full Stack Developer
          </h2>

          <p>
            Learn industry-relevant technologies and build
            real-world projects with practical training.
          </p>

        </div>

        <Link to="/contact">
          Enquire Now →
        </Link>

      </section>

    </div>
  );
};

export default JavaFullStack;